module.exports = __webpack_public_path__ + "img/five-crowns.9b4a6ae0.jpg";